/* eslint-disable */
export default {
  from: 'Lähettäjä',
  to: 'Vastaanottaja',
  enterNameOrNumber: 'Anna nimi tai numero...',
  typeMessage: 'Kirjoita viesti...',
  send: 'Lähetä',
  emoji: 'Emoji',
} as const;

// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number or Name..."@#@
// @key: @#@"typeMessage"@#@ @source: @#@"Type message..."@#@
// @key: @#@"send"@#@ @source: @#@"Send"@#@
// @key: @#@"emoji"@#@ @source: @#@"Emoji"@#@
